'use strict'

import ApiClient from './ApiClient'

export default class ManagePersonRepository {
  /**
   * 名刺人物情報を削除します。
   * @param {string|int} person_id 人物ID
   * @returns {*}
   */
  delete (person_id) {
    return ApiClient().delete(`/mgmt/persons/${person_id}`)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/ManagePersonRepository.js